import type { User } from '@/lib/api';

/**
 * Still waiting on a first sign-in? Cognito is the authority when it answered; the
 * database status is the fallback for when it did not (and for local development).
 * They disagreed once — an account showed "Employee, active" while its invitation had
 * quietly expired — which is why the badge no longer trusts the database alone.
 */
/**
 * Can be given work: uses the app and is not suspended or archived. An invited person
 * counts — the office plans ahead of someone's first sign-in — and so does anyone with
 * app access whatever their role: an office manager who also goes on site is on the
 * board like everyone else.
 */
export function canBeAssigned(user: User): boolean {
  return (user.status === 'active' || user.status === 'invited') && user.appAccess;
}

export function awaitingSignIn(user: User): boolean {
  if (user.status === 'suspended') return false;
  if (user.signIn) return user.signIn === 'invited' || user.signIn === 'none';
  return user.status === 'invited';
}
